<template>
<div>
 <div :class="windowClass" v-if="!printsale">
     <div class="text-right" v-if="IS_SELECTED">
            <v-btn small class="ma-1" @click="printsale = true"><v-icon left small>mdi-printer</v-icon> Sales</v-btn>
            <v-btn small class="ma-1" color="warning" @click="verify=false, confirm_text='Re-Verified Fishcar Sales?', confirm = true"  v-if="!VARIFIEDBTN"><v-icon left small>mdi-printer</v-icon> Re-Verify</v-btn>
            <v-btn small class="ma-1" color="success" v-if="VARIFIEDBTN" @click="verify=true, confirm_text='Verified Fishcar Sales?', confirm = true"><v-icon left small>mdi-check</v-icon> Verified</v-btn>
     </div>
        <v-row no-gutters>
            <v-col md="12" class="pa-1">
                     <v-card class="pa-2">
                        <v-card-title>
                        <v-icon left color="primary">mdi-calendar</v-icon> DAILY FISHCARS SALES  
                        
                            
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-menu
                            ref="menu"
                            v-model="datemenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="selected_date"
                                label="Select Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                single-line
                                class="mr-2"
                                hide-details
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="selected_date" no-title scrollable @input="datemenu = false, selected_fishcar={}, getTransactions()">
                            
                            </v-date-picker>
                        </v-menu>
                        <v-autocomplete
                            v-model="selected_fishcar"
                            :items="FISHCARS"
                            label="Select Fishcar"
                            item-text="name"
                            item-value="id"
                            @change="FilterTransactions()"
                            single-line
                            return-object
                            hide-details
                        >
                        <template v-slot:item="{ item }">
                            {{item.name}} 
                            <template v-if="item.status=='verified'">
                                    <v-icon right color="success">mdi-check</v-icon>
                            </template>
                            </template>
                        </v-autocomplete>
                         
                        </v-card-title>
                        <v-divider />
                             <v-data-table
                                class="va-table"
                                dense
                                :headers="headers"
                                :items-per-page="10000"
                                hide-default-footer
                                :items="TRANSACTIONS"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                         
                                        <td>
                                            {{item.customer_name}}

                                        </td>
                                        <td>{{ item.name }} </td>
                                        <td class="text-right">
                                            {{item.kilos}}
                                        </td>
                                        <td class="text-right">
                                            {{item.price}}
                                        </td>
                                    <td style="background: #eee;" class="text-right">
                                        <span v-if="item.payment_type=='cash'">{{$money($IsNum(item.kilos) * $IsNum(item.price))}}</span>
                                    </td>
                                        <td style="background: #dedede;" class="text-right">
                                        <span v-if="item.payment_type=='credit'">{{$money($IsNum(item.kilos) * $IsNum(item.price))}}</span>
                                        </td>
                                        <td style="background: #ccc;" class="text-right">{{$money($IsNum(item.kilos) * $IsNum(item.price))}}</td>
                                    </tr>
                                    </tbody>
                                     <tfoot>
                                        <tr>
                                            
                                            <th colspan="2" class="text-left">TOTAL:</th>
                                            <th class="text-right">{{$money(TOTAL_KILOS)}}</th>
                                            <th></th>
                                            <th class="text-right">{{$money(TOTAL_CASH)}}</th>
                                            <th class="text-right">{{$money(TOTAL_CREDIT)}}</th>
                                            <th class="text-right">{{$money(TOTAL_CASH + TOTAL_CREDIT)}}</th>
                                        </tr>
                                     </tfoot>
                                </template>
                                </v-data-table>
                    </v-card>
            </v-col>
            <v-col md="9" class="pa-1">
                <v-card>
                        <v-card-title>
                        <v-icon left color="primary">mdi-file-edit</v-icon> SUMMARY
                        </v-card-title>
                        <v-card-text>
                            <v-data-table
                                class="va-table"
                                dense
                                :headers="headers2"
                                :items-per-page="10000"
                                hide-default-footer
                                :items="SALES_SUMMARIES"
                                >

                                 <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                        <td>{{item.fish}}</td>
                                        <td class="text-right">{{$money(item.kilos)}}</td>
                                        <td class="text-right">{{$money(item.price)}}</td>
                                        <td class="text-right">{{$money($IsNum(item.kilos) * $IsNum(item.price))}}</td>
                                    </tr>
                                    </tbody>
                                   <tfoot>
                                        <tr>
                                            
                                            <th class="text-left">TOTAL:</th>
                                            <th class="text-right">{{$money(TOTAL_KILOS)}}</th>
                                            <th></th>
                                            <th class="text-right">{{$money(TOTAL_CASH + TOTAL_CREDIT)}}</th>
                                        </tr>
                                     </tfoot>
                                </template>

                                </v-data-table>
                        </v-card-text>
                </v-card>
            </v-col>
             <v-col md="3" class="pa-1">
                 <v-card>
                        <v-card-title>
                        <v-icon left color="primary">mdi-file-swap</v-icon>TLC
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col md="8" class="text-right">
                                    <p class="pt-1">TICKET: </p>
                                    <p class="pt-2">PARKING FEE: </p>
                                    <p class="pt-2">LABOR: </p>
                                     <p class="pt-2">COMMISION: </p>
                                </v-col>
                                  <v-col md="4" class="pr-4">
                                          <v-text-field
                                          :disabled="!VARIFIEDBTN"
                                          dense
                                            class="va-right"
                                          v-model="ticket"
                                          height="22"
                                          />
                                          <v-text-field
                                           :disabled="!VARIFIEDBTN"
                                          dense
                                          value="0"
                                          class="va-right"
                                          height="22"
                                          v-model="parking"
                                          />
                                          <v-text-field
                                           :disabled="!VARIFIEDBTN"
                                          dense
                                           v-model="labor"
                                           class="va-right"
                                          height="22"
                                          />
                                          <v-text-field
                                           :disabled="!VARIFIEDBTN"
                                           v-model="commission"
                                           class="va-right"
                                          dense
                                          height="22"
                                          />
                                        
                                </v-col>
                            </v-row>
                            <v-footer class="pt-0 pb-0 pr-2 subtitle-1 mb-1" color="#EEEEEE">
                                <v-spacer></v-spacer>
                                DEDUCTION:  <span class="ml-4">{{$money(TOTAL_DEDUCTION)}}</span>
                            </v-footer>
                             <v-footer class="pt-0 pb-0 pr-2 subtitle-1" dark color="secondary">
                                <v-spacer></v-spacer>
                                NET SALES:  <span class="ml-4">{{$money(TOTAL_NET)}}</span>
                            </v-footer>
                        </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <va-confirm  :show="confirm" cancelbtn="No" okbtn="verified" :text="confirm_text" @DialogEvent="ConfirmEvent"/>
  </div>
   <print-fishcar v-if="printsale" :show="printsale" :fishcar="selected_fishcar" :selected_date="selected_date" :tcl="{ticket:ticket, parking: parking, labor:labor, commission:commission}" @DialogEvent="prEvent"/>
</div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
      mixins: [API_MIXINS],
    data: () => ({
        confirm_text:'',
        printsale: false,
        form: false,
        confirm: false,
        datemenu: false,
        locked: true,
        verifiedBTN: false,
        verify:false,
        sales: {},
        search:'',
        state: 'new',
        ticket:0,
        parking:0,
        labor: 0,
        commission:0,
        selected_date: '',
        selected_fishcar:{},
         headers: [
            { text: 'Customer', value:'customer', sortable: false },
            { text: 'Kind', value:'kind', sortable: false },
            { text: 'Kilos', value:'kilos' , sortable: false, align: 'right'},
            { text: 'Price', value:'Price' , sortable: false, align: 'right'},
            { text: 'Cash', sortable: false, align: 'right'},
            { text: 'Credit', sortable: false, align: 'right'},
            { text: 'Total', sortable: false, align: 'right'},
        ],
         headers2: [
            { text: 'Kind', value:'kind', sortable: false},
            { text: 'Kilos', value:'kilos', sortable: false,align: 'right'},
            { text: 'Price', value:'price', sortable: false,align: 'right'},
            { text: 'Total', sortable: false, align: 'right'},
        ],
         headers3: [
            { text: 'ITEM',align: 'right' },
            { text: 'AMOUNT',align: 'left'},
        ],
        settings:[],
        customers:[],
        sales_summary_items: [],
        tlc_data:{}
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.selected_date = this.$moment().format('YYYY-MM-DD')
          this.getTransactions()
          this.getCustomers()
          this.loadSetting()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
    IS_ADMIN(){
        if(this.$session.get('role') == 'administrator') {
            return true
        } 
        return false
      },
      VARIFIEDBTN() {
          if(this.IS_ADMIN) {
               return this.verifiedBTN
          }
         return false
      },
      TRANSACTIONS() {
          if(this.IS_SELECTED) {
              return this.$store.state.todays_transactions
          }
          return []
      },
      IS_SELECTED(){
          if(this.selected_fishcar.id != null && this.selected_fishcar.id != undefined) {
              return true
          }
          return false
      },
      FISHCARS(){
       return this.$store.state.todays_fishcars
      },
      TOTAL_KILOS() {
        let total = 0
        let items = this.TRANSACTIONS
        for(var i= 0;i< items.length;i++) {
             total += this.$IsNum(items[i].kilos)
        }
        return total
      },
      TOTAL_CASH() {
        let total = 0
        let items =  this.TRANSACTIONS
        for(var i= 0;i< items.length;i++) {
            if(items[i].payment_type == "cash") {
                total += this.$IsNum(items[i].kilos) * this.$IsNum(items[i].price)
            }
        }
        return total
      },
       TOTAL_CREDIT() {
        let total = 0
        let items =  this.TRANSACTIONS
        for(var i= 0;i< items.length;i++) {
            if(items[i].payment_type == "credit") {
                total += this.$IsNum(items[i].kilos) * this.$IsNum(items[i].price)
            }
        }
        return total
      },
        KINDS(){
            var groupBy = this.$groupBy('name')
            var fish = groupBy(this.TRANSACTIONS)
            return fish
        },
        SALES_SUMMARIES() {
            var obj = this.KINDS
            var result = []
            for (let key in obj){
                if(obj.hasOwnProperty(key)){
                   result = result.concat(this.groupByPrice(key, obj[key]))
                }
            }
            this.allPrices(result)
            return  result
        },
        TICKET(){
            var add = this.$IsNum(this.getSettingVal('ticket_add'))
            return ((this.$IsNum(this.TOTAL_KILOS) * this.$IsNum(this.getSettingVal('ticket_multiplier')) ) + add).toFixed(0)
        },
        LABOR() {
            var kilos = this.TOTAL_KILOS
             var labor1 = this.$IsNum(kilos) * this.$IsNum(this.getSettingVal('labor_1_multiplier'))
             var labor2 = (this.$IsNum(kilos) * this.$IsNum(this.getSettingVal('labor_2_multiplier'))) * this.$IsNum(this.MIDPRICE) + this.$IsNum(kilos)
            return (labor2 + labor1).toFixed(0)
        },
        MIDPRICE(){
             return this.$store.state.midprice
        },
        COMMISSION(){
            var sales = this.TOTAL_CASH + this.TOTAL_CREDIT
            var comm = this.$IsNum(this.selected_fishcar.commission)/100
            return (this.$IsNum(sales) * comm).toFixed(0)
        },
        CASH_SERVICE_CHARGE() {
            var sc = this.$IsNum(this.getSettingVal('service_charge'))
            var arr = this.TRANSACTIONS
            let filter = arr.reduce((a, o) => o.payment_type=='cash'?a += this.$IsNum(o.kilos)*sc:a+=0, 0)
            return filter
        },
        CREDIT_SERVICE_CHARGE() {
            var sc = this.$IsNum(this.getSettingVal('service_charge'))
             var arr = this.TRANSACTIONS
            let filter = arr.reduce((a, o) => o.payment_type=='credit'?a += this.$IsNum(o.kilos)*sc:a+=0, 0)
            return filter
        },
        TOTAL_DEDUCTION(){
            return  this.$IsNum(this.ticket) + this.$IsNum(this.parking) + this.$IsNum(this.labor) + this.$IsNum(this.commission)
        },
        TOTAL_NET(){
            var total = this.TOTAL_CASH + this.TOTAL_CREDIT
            return total - this.TOTAL_DEDUCTION
        }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn', 'setTodaysTransactions', 'setMidprice']),
    prEvent() {
        this.printsale = false
    },
    ConfirmEvent(response) {
         console.log(response)
         this.confirm = false
         if(response == 'ok') {
             if(this.verify) {
                  this.Verified()
             } else {
                 this.re_verify()
             }
            
         }
     },
     re_verify(){
          var param = {
                 supplier: this.selected_fishcar.id,
                for_date: this.selected_date,
          }
         this.$http.post("summary/remove", param).then(response => {
                response.data.status?this.VA_ALERT('success', response.data.message):this.VA_ALERT('error', response.data.message)
               //this.selected_fishcar = {}
                this.GET_TODAYS_FISHCARS({param1: this.selected_date})
               // setTimeout(() =>{ this.Verified()}, 2500)
            }).catch(e => {
            console.log(e.data)
          }) 
     },
     Verified(){
          var param = {
                ticket: this.ticket.toString(),
                parking: this.parking.toString(),
                labor2: this.labor.toString(),
                commission:this.commission.toString(),
                gross_sales: (this.TOTAL_CASH + this.TOTAL_CREDIT).toString(),
                net_sales: this.TOTAL_NET.toString(),
                supplier: this.selected_fishcar.id,
                for_date: this.selected_date,
                cash_sales: this.TOTAL_CASH.toString(),
                credit_sales: this.TOTAL_CREDIT.toString(),
                service_charge : this.CASH_SERVICE_CHARGE.toString(),
                service_charge_credit : this.CREDIT_SERVICE_CHARGE.toString(),
                total_kilos: this.TOTAL_KILOS.toString(),
          }
         this.$http.post("summary/save", param).then(response => {
                response.data.status?this.VA_ALERT('success', response.data.message):this.VA_ALERT('error', response.data.message)
               //this.selected_fishcar = {}
                this.GET_TODAYS_FISHCARS({param1: this.selected_date})
            }).catch(e => {
            console.log(e.data)
          }) 
      },
        allPrices(PriceArr){
           let filter = PriceArr.reduce((a, o) => a.concat(this.$IsNum(o.price)), [])
          var prices = filter.sort(function(a, b){return a-b})
           if((prices.length % 2) > 0) {
               this.setMidprice(prices[Math.floor(prices.length/2)])
          } else {
            this.setMidprice(prices[(prices.length / 2) - 1])
          }
          this.setCharges()
        },
      groupByPrice(fish, arr){
           var groupBy = this.$groupBy('price')
            var obj = groupBy(arr)
            var result = []
            for (let key in obj){
                if(obj.hasOwnProperty(key)){
                  result.push({fish: fish, price:key, kilos:this.sumWeight(obj[key])})
                }
            }
          return result
      },
      sumWeight(obj){
            var weight = 0
            for (var i=0;i<obj.length;i++){
                weight += this.$IsNum(obj[i].kilos)
            }
            return weight
      },
      getTransactions(){
          this.GET_TRANSACTIONS({param1: this.selected_date})
          this.GET_TODAYS_FISHCARS({param1: this.selected_date})
      },
      FilterTransactions() {
        this.sales_summary_items=[]
        var result = []
        let items = this.$store.state.qued_transactions
        for(var i= 0;i< items.length;i++) {
            if(items[i].supplier == this.selected_fishcar.id) {
              result.push(items[i])
            }
        }
        this.setTodaysTransactions(result)
        //setTimeout(()=> {this.setCharges()} , 1000)
      },
      setCharges() {
        this.getSummary()
          
      },
      getCustomers: function() { 
          this.$http.post("customer/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.customers = response.data.data:this.customers = []
          }).catch(e => {
           console.log(e.data)
         })
     },
     
    loadSetting() {
          this.$http.post("setting/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.settings = response.data.data:this.settings = []
          }).catch(e => {
           console.log(e.data)
         })
      },
      getSettingVal(name) {
          for(var i =0;i<this.settings.length;i++) {
              if(this.settings[i].name == name) {
                  return this.settings[i].value
              }
          }
          return false
      },
      getSummary(){
        this.verifiedBTN = false
        this.ticket = 0
        this.parking = 0
        this.labor = 0
        this.commission = 0
          this.$http.post("summary/query", {supplier:this.selected_fishcar.id,method: "by_supplier", for_date: this.selected_date}).then(response => {
             if(response.data.data != null) {
                 this.ticket = response.data.data[0].ticket
                    this.parking = response.data.data[0].parking
                    this.labor = response.data.data[0].labor2
                    this.commission = response.data.data[0].commission  
                    
             } else {
                 this.ticket = this.TICKET
                this.parking = 0
                this.labor = this.LABOR
                this.commission = this.COMMISSION
                this.verifiedBTN = true
             }

          }).catch(e => {
           console.log(e.data)
         })
      }
    }
  }
</script>